import styled from '@emotion/styled';

export const ButtonBase = styled.button`
  display: inline-flex;
  align-items: center;
  position: relative;
  border: none;
  padding: 0 16px;
  font: inherit;
  cursor: pointer;
  outline: inherit;

  border-radius: 12px;
`;
